import { create } from "zustand";

type UsersFilterState = {
  searchValue: string | null;
  statusFilter: string | null;
  ordering: string | null;
  setSearchValue: (searchValue: string | null) => void;
  setStatusFilter: (status: string | null) => void;
  setOrdering: (ordering: string | null) => void;
};

export const useUsersFilterStore = create<UsersFilterState>((set) => ({
  searchValue: null,
  statusFilter: null,
  ordering: "-date_joined",
  setSearchValue: (searchValue) => set({ searchValue }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setOrdering: (ordering) => set({ ordering }),
}));
